// extracted by mini-css-extract-plugin
export default {"footermain_div":"footer_footermain_div__EV8AS","first_div":"footer_first_div__sAL46","fourth_seg":"footer_fourth_seg__l7X2S"};